import DatepickerRange from 'theme/Datepicker/DatepickerRange'
import React from 'react'
import HelperDate from 'utils/helper-date'

const ThemedRangeDatepicker = ({ onSelect, range, max = false, min = false, style = {} }) => {
	
	const defaultMaxMinYears = 100
	
	max = (max === false) ? HelperDate.date().add( defaultMaxMinYears, 'years').endOf('year' ).toDate() : max
	min = (min === false) ? HelperDate.date().subtract( defaultMaxMinYears, 'years').endOf('year' ).toDate() : min
	
	return (
		<DatepickerRange
			style={ style }
			value={ range }
			onSelect={ onSelect }
			min={ min }
			max={ max }
		/>
	)
}

export default ThemedRangeDatepicker
